import Container from '@ui/container/container';

const ProjectImageSkeletonLoader = ({ loading }: { loading: boolean }) => {
  return (
    <Container
      style={{
        position: 'absolute',
        top: 96,
        left: 0,
        width: '100%',
        height: '100%',
        display: loading ? 'block' : 'none',
      }}
    >
      <Container
        skLoader={{
          height: 156,
          width: 370,
          radius: 16,
          loading: loading,
          design: 'GlobalCont3',
        }}
      ></Container>
      <Container
        skLoader={{
          height: 195,
          width: 344,
          radius: 16,
          loading: loading,
          design: 'GlobalCont2',
        }}
      ></Container>
    </Container>
  );
};

export default ProjectImageSkeletonLoader;
